import { useSelector } from 'react-redux';
import React, { Fragment, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { OnboardingLayout } from 'layouts/OnboardingLayout';
import { useTranslation } from 'hooks/useTranslation';
import { useMetrics } from 'hooks/metrics/useMetrics';
import './style.scss';
import { OnboardingLoading } from 'components/onboarding/components/OnboardingLoading';
import { OnboardingButton } from 'components/onboarding/components/DefaultButton';
import { getRegion } from 'utils/Region';
import { QRLinkingErrorHeader } from '../QRLinkingErrorHeader';
import { QR_LINKING_ERROR_TIME_EXCEEDED_KEYS } from '../translationKeys';

export const QRLinkingErrorTimeExceeded = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(QR_LINKING_ERROR_TIME_EXCEEDED_KEYS),
    [translationMapper],
  );

  const { alerta_errordesvinculacionqr_icono_advertencia = '' } = useSelector(
    state => state.asset,
  );

  return (
    <Fragment>
      <div className="QRLinkingErrorTimeExceeded">
        <QRLinkingErrorHeader />

        <div className="QRLinkingErrorTimeExceeded__Container">
          {alerta_errordesvinculacionqr_icono_advertencia ? (
            <img
              className="QRLinkingErrorTimeExceeded__Container__AlertIcon"
              src={alerta_errordesvinculacionqr_icono_advertencia}
              alt="advertencia"
            />
          ) : (
            <span className="QRLinkingErrorTimeExceeded__Container__AlertIcon" />
          )}

          <h2 className="QRLinkingErrorTimeExceeded__Container__Title">
            {translatedTexts.TITLE}
          </h2>
          <p className="QRLinkingErrorTimeExceeded__Container__P1">
            {translatedTexts.P1_PART_1}
            <br />
            {translatedTexts.P1_PART_2}
          </p>

          <OnboardingButton
            variant="secondary"
            size="large"
            onClick={() =>
              navigate(`/${getRegion()}/landing`, { replace: true })
            }
            className="QRLinkingErrorTimeExceeded__Container__MainButton"
            textContent={translatedTexts.ACCEPT_BUTTON}
          />
        </div>
      </div>
    </Fragment>
  );
};
